<template>
    <el-dialog
    title="请选择"
    width="800px"
    class="rule-dialog"
    :visible.sync="dialogVisible"
    :before-close="closeDialog"
    :close-on-click-modal="false">
        <el-row class="rule-dialog-search">
            <el-col :span="24">
                <el-row>
                    <el-col class="sn-search-item">
                        <el-select v-model="searchData['type']">
                            <el-option v-for="item in typeList" :key="item.prop" :label="item.label" :value="item.prop"></el-option>
                        </el-select>
                    </el-col>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['param']"></el-input>
                    </el-col>
                    <div>
                    <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                        {{'查 询'}}
                    </el-button>
                    <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                        {{'重 置'}}
                    </el-button>
                </div>
                </el-row>
            </el-col>
        </el-row>
        <Mtable
        :config="config"
        :pageTotal="pageTotal"
        :tableData="tableData"
        @pageChange="pageChange"
        @sizeChange="sizeChange"
        @rowDBclick="rowDBclick"
        @onSelectionChange="onSelectionChange">
        </Mtable>
        <span slot="footer" class="dialog-footer">
            <el-button class="sn-search-button" @click="closeDialog">取消</el-button>
            <el-button class="sn-search-button" type="primary" @click="saveData">保存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import Mtable from '../../../components/IdentityComponent/Main';
import { getBarCodeRule } from '../../../api/Commodity';
import { config } from './RuleDialogConfig';
export default {
    components: { Mtable },
    props: {
        dialogVisible: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            config: config,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            selected: [],
            searchData: {
                type: 'ruleCode'
            },
            searchLoading: false,
            typeList: config.table.columns
        };
    },
    methods: {
        closeDialog() {
            this.$emit('update:dialogVisible', false);
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        loadData() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                status: 0,
                [this.searchData.type]: this.searchData.param
            };
            this.searchLoading = true;
            getBarCodeRule(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        saveData() {
            if (this.selected.length !== 1) {
                this.$message.warning('请勾选一条明细');
                return;
            }
            const rowsParams = {
                ruleCode: this.selected[0].ruleCode,
                ruleName: this.selected[0].ruleName,
                codeNum: this.selected[0].codeNum
            };
            this.$emit('saveData', rowsParams);
            this.closeDialog();
        },
        rowDBclick(row) {
            const rowsParams = {
                ruleCode: row.ruleCode,
                ruleName: row.ruleName,
                codeNum: row.codeNum
            };
            this.$emit('saveData', rowsParams);
            this.closeDialog();
        },
        searchChange() {
            this.pageNo = 1;
            this.loadData();
        },
        restSearchChange() {
            this.searchData = this.$options.data.call(this).searchData;
        },
        onSelectionChange(selection) {
            this.selected = selection;
        }
    },
    mounted() {
        this.searchChange();
    }
};
</script>
<style lang="less">
.rule-dialog{
    .rule-dialog-search{
        margin-bottom: 16px;
    }
    .nPanel .el-table{
        height: 400px!important;
    }
}
</style>